<template>
  <div class="main" :class="{'main-hide-text': shrink}">
    <!--左边菜单栏-->
    <div class="sidebar-menu-con"
         :style="{width: shrink?'60px':'200px', overflow: shrink ? 'visible' : 'auto',background: menuTheme == 'dark' ? '#495060' : '#fff'}">
      <shrinkable-menu
        :shrink="shrink"
        @on-change="handleSubmenuChange"
        :theme="menuTheme"
        :before-push="beforePush"
        :open-names="openedSubmenuArr"
        :menu-list="menuList">
        <div slot="top" class="logo-con">
          <div v-show="!shrink"
               style="display: flex;align-items: center;justify-content: space-around">
            <img src="../assets/images/logo.png" key="max-logo" style="width: 39px;height: 39px;"/>
            <span :style="{color: menuTheme == 'dark' ? '#fff' : '#495060'}"
                  style="font-size: 20px;color: white">嘉信物联</span>
          </div>
          <img v-show="shrink" src="../assets/images/logo.png" key="min-logo"
               style="padding: 5px;"/>
        </div>
      </shrinkable-menu>
    </div>

    <div class="main-header-con" :style="{paddingLeft: shrink?'60px':'200px'}">
      <div class="main-header">
        <!--menu切换按钮-->
        <div class="navicon-con">
          <Button :style="{transform: 'rotateZ(' + (this.shrink ? '-90' : '0') + 'deg)'}"
                  style="border: none"
                  type="text"
                  @click="toggleClick">
            <!--<Icon type="ios-menu" size="30"/>-->
            <Icon type="ios-menu-outline" size="30"/>
          </Button>
        </div>

        <!--面包屑-->
        <div class="header-middle-con">
          <div class="main-breadcrumb">
            <breadcrumb-nav :currentPath="currentPath"></breadcrumb-nav>
          </div>
        </div>
        <div class="header-avator-con">
          <router-link to='/cube' tag='zhf'><el-button round size="small">大屏模式</el-button></router-link>
          <!--全屏-->
          <full-screen v-model="isFullScreen" @on-change="fullscreenChange"></full-screen>
          <lock-screen></lock-screen>
          <message-tip v-model="mesCount"></message-tip>
          <dd>&nbsp;&nbsp;&nbsp;</dd>
          <!-- <button @click="hreftwo" class="test-one">大屏模式</button> -->
          <options></options>
          <!--<theme-switch></theme-switch>-->

          <div class="user-dropdown-menu-con">
            <Row type="flex" justify="end" align="middle" class="user-dropdown-innercon">
              <Dropdown transfer trigger="click" @on-click="handleClickUserDropdown">
                <a href="javascript:void(0)"
                   style="display: flex;justify-content: center;align-items: center">
                  <span class="main-user-name">{{ userName }}</span>
                  <Icon type="logo-reddit" size="30" style="margin-left: 5px;"/>
                  <img src="../assets/images/user.jpg" alt=""
                       style="width: 32px;height: 32px;border-radius: 50px;margin-left: 10px;">
                </a>
                <DropdownMenu slot="list">
                  <DropdownItem name="ownSpace">个人中心</DropdownItem>
                  <DropdownItem name="changepwd">修改密码</DropdownItem>
                  <DropdownItem name="loginout" divided>退出登录</DropdownItem>
                </DropdownMenu>
              </Dropdown>
              <!--<Avatar :src="avatorPath" style="background: #619fe7;margin-left: 10px;"></Avatar>-->
              <!--<Avatar :src="avatorPath" style="background: #619fe7;margin-left: 10px;"></Avatar>-->

            </Row>
          </div>
        </div>
        <div class="tags-con">
          <tags-page-opened :pageTagsList="pageTagsList"></tags-page-opened>
        </div>
      </div>
    </div>
    <div class="single-page-con" :style="{left: shrink?'60px':'200px'}">
      <div class="single-page">
        <keep-alive :include="includeCache">
          <router-view></router-view>
          {{openedSubmenuArr}}
        </keep-alive>
      </div>
    </div>
  </div>
</template>

<script>
  import shrinkableMenu from '../components/main-components/shrinkable-menu/shrinkable-menu.vue';
  import breadcrumbNav from '../components/main-components/breadcrumb-nav.vue';
  import tagsPageOpened from '../components/main-components/tags-page-opened.vue';
  import fullScreen from '../components/main-components/fullscreen.vue';
  import lockScreen from '../components/main-components/lockscreen/lockscreen.vue';
  import messageTip from '../components/main-components/message-tip.vue';
  import themeSwitch from '../components/main-components/theme-switch/theme-switch.vue';
  //import options from '../components/main-components/options.vue';
  import util from '@/libs/util.js'
  import Cookie from 'js-cookie'

  export default {
    components: {
      shrinkableMenu,
      breadcrumbNav,
      tagsPageOpened,
      fullScreen,
      lockScreen,
      messageTip,
      themeSwitch//,
      //options
    },
    data() {
      return {
        mesCount: 2,
        isFullScreen: false,                  // 是否全屏
        shrink: true,
        userName: Cookie.get('user') ? Cookie.get('user') : '李炜强',
        openedSubmenuArr: this.$store.state.app.openedSubmenuArr,
        routerName: 'home_index',
        isChangeRouter: false,
      }
    },
    computed: {
      currentPath() {
        return this.$store.state.app.currentPath; // 当前面包屑数组
      },
      menuList() {
        return this.$store.state.app.menuList;    // 菜单栏列表
      },
      pageTagsList() {
        return this.$store.state.app.pageOpenedList; // 打开的页面的页面对象
      },
      dontCache() {
        return this.$store.state.app.dontCache;     // 不缓存页面
      },
      cachePage() {
        return this.$store.state.app.cachePage;     // 缓存页面
      },
      menuTheme() {
        return this.$store.state.app.menuTheme;    // 菜单主题
      },
      avatorPath() {                             // 用户头像地址
        return localStorage.avatorImgPath;
      },
      includeCache() {                             // 只缓存当前tab栏
        let arr = [];
        if (this.pageTagsList.length) {
          this.pageTagsList.forEach(val => {
            arr.push(val.name);
          })
        }
        return arr;
      }
    },
    methods: {
      init() {
        // 判断当前是否登录
        if (util.isLogin(this, Cookie.get('access'))) {
          let pathArr = util.setCurrentPath(this, this.$route.name);

          this.$store.commit('updateMenulist');

          if (pathArr.length >= 2) {
            this.$store.commit('addOpenSubmenu', pathArr[1].name);
          }
        }
        this.checkTag(this.$route.name);
      },
      // 子菜单切换
      handleSubmenuChange(name) {
        // this.name = name;
      },
      beforePush() {
        return true;
      },
      // 切换菜单栏
      toggleClick() {
        this.shrink = !this.shrink;
      },
      // 全屏
      fullscreenChange(isFullScreen) {
        // console.log(isFullScreen);
      },
      hreftwo(){
        this.$router.push({
          name: 'cube_zhf'
        });
      },
      // 检测当前tags
      checkTag(name) {
        let openpageHasTag = this.pageTagsList.some(item => {
          if (item.name === name) {
            return true;
          }
        });

        if (name == 'refund') {
          return true;
        }

        if (!openpageHasTag) { //  解决关闭当前标签后再点击回退按钮会退到当前页时没有标签的问题
          util.openNewPage(this, name, this.$route.params || {}, this.$route.query || {});
        }
      },
      // 用户头像点击事件
      handleClickUserDropdown(name) {
        if (name === 'ownSpace') {
          util.openNewPage(this, 'owns_index');
          this.$router.push({
            name: 'owns_index'
          });
        } else if (name === 'changepwd') {
          // 修改密码
          this.$router.push({
            name: "changepsw"
          });
        } else if (name === 'loginout') {
          // 退出登录
          this.$store.commit('logout', this);
          this.$store.commit('clearOpenedSubmenu');
          Cookie.remove('token');
          this.$router.push({
            name: 'login'
          });
        }
      },
    },
    mounted() {
      this.init();
    },
    watch: {
      '$route'(to) {
        this.$store.commit('setCurrentPageName', to.name);
        // 监听当前路由是否跳转,设置对应面包屑
        let pathArr = util.setCurrentPath(this, to.name);
        if (pathArr.length > 2) {
          this.$store.commit('addOpenSubmenu', pathArr[1].name);
        }

        this.checkTag(to.name);
        localStorage.currentPageName = to.name;
        // backgroundColor: routerName == 'home_index' ? '#0c2d41' : 'white'
        // this.routerName = to.name;
      },
    },
    created() {
      // 显示打开的页面的列表
      this.$store.commit('setOpenedList');
    }
  }
</script>

<style lang="less">
  @import "./main.less";
</style>



// WEBPACK FOOTER //
// src/views/main.vue